export const sanitizeLandmarks = (html: string): string => {
  const doc = new DOMParser().parseFromString(html, 'text/html');

  // Convert <header> to <div>
  doc.querySelectorAll('header').forEach(header => {
    const div = doc.createElement('div');
    Array.from(header.attributes).forEach(({ name, value }) => div.setAttribute(name, value));
    div.append(...Array.from(header.childNodes));
    header.replaceWith(div);
  });

  // Keep the first h1, convert all subsequent ones to <p class="accessible-heading-h1">
  const [, ...extraH1s] = doc.querySelectorAll('h1');
  extraH1s.forEach(h1 => {
    const p = doc.createElement('p');
    p.className = 'accessible-heading-h1';
    p.append(...Array.from(h1.childNodes));
    h1.replaceWith(p);
  });

  // Convert h2–h6 to <p class="accessible-heading-hN">
  doc.querySelectorAll('h2, h3, h4, h5, h6').forEach(heading => {
    const p = doc.createElement('p');
    p.className = `accessible-heading-${heading.tagName.toLowerCase()}`;
    p.append(...Array.from(heading.childNodes));
    heading.replaceWith(p);
  });

  return doc.body.innerHTML;
};
